export default "<div *ngIf=\"loaderService.isLoading | async\" class=\"progress\" style=\"width: 100%\">\r\n  <div class=\"indeterminate\"></div>\r\n</div>\r\n"